module.exports = __webpack_public_path__ + "img/safari-250.46bad094.png";